'use client'
import { ContainerCustom, Pagination } from '@/components'
import {
  BlogPostsEmpty,
  BlogPostsGridSkeleton,
  CardCollection,
  TitleIcon,
  useBlogPostsByCategory,
} from '@/features/blogs'
import { Box, Grid } from '@mui/material'
import { parseAsInteger, useQueryState } from 'nuqs'

type Props = {
  categoryId?: number
  pageSize?: number
  showPageSizeSelector?: boolean
  title?: string
  showPagination?: boolean
}

export const NewUpdateCollections = ({ categoryId = 6, pageSize = 15, title, showPagination = true }: Props) => {
  const [page, setPage] = useQueryState('page', parseAsInteger.withDefault(1))

  // Fetch blog posts theo categoryId với pagination
  const { data, isLoading, error } = useBlogPostsByCategory({
    categoryId,
    pageSize,
    currentPage: page,
    action: 'get_post_list',
    sortBy: 'Latest',
  })

  // Tính toán pagination
  const totalCount = data?.data?.total_count || 0

  return (
    <Box
      component={'section'}
      sx={{
        bgcolor: 'mbgSecond.main',
      }}
    >
      <ContainerCustom
        sx={{
          padding: '16px',
          margin: '0 auto',
          py: {
            xs: 4,
            md: 8,
            lg: 12,
          },
          display: 'flex',
          flexDirection: 'column',
          gap: {
            xs: 3,
            md: 4,
            lg: 5.5,
          },
        }}
        component={"div"}
      >
        <TitleIcon
          typographyProps={{
            variant: 'h2',
            fontSize: { xs: '20px', sm: '26px', md: '28px', lg: '32px' },
            fontWeight: 800,
            lineHeight: 1.5,
          }}
          title={title || 'MỚI CẬP NHẬT'}
          underline={false}
        />

        <Box>
          {/* Hiển thị loading skeleton */}
          {isLoading && <BlogPostsGridSkeleton count={pageSize} />}

          {/* Hiển thị empty state khi có lỗi hoặc không có data */}
          {(error || !data?.data?.items.length) && !isLoading && (
            <BlogPostsEmpty
              message={error ? 'Có lỗi xảy ra khi tải bài viết' : 'Không có bài viết mới cập nhật'}
            />
          )}

          {/* Hiển thị data khi có articles */}
          {!isLoading && !error && !!data?.data?.items.length && (
            <>
              <Grid container spacing={2}>
                {data?.data?.items.map((article) => (
                  <Grid
                    key={article.url_key}
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 4,
                      lg: 3,
                      xl: 2.4,
                    }}
                  >
                    <CardCollection article={article} />
                  </Grid>
                ))}
              </Grid>

              {/* Pagination */}
              {showPagination && <Pagination defaultCurrent={page} total={totalCount} pageSize={pageSize} />}
            </>
          )}
        </Box>
      </ContainerCustom>
    </Box>
  )
}
